import { Feature } from "ol";
import { Geometry, Point } from "ol/geom";
import ParserBase, { TokenType } from "./parserBase";

export default class LabelParser extends ParserBase {
    
    parseFeature(): Feature<Geometry> {
        let token = this.skipUntil(TokenType.TEXT);
        if (token === TokenType.EOF)
            return undefined;

        let tokenString = this._lines[this._cursor].replace("&T ", "");
        let y = -tokenString.substr(0, tokenString.indexOf(" "));
        tokenString = tokenString.substr(tokenString.indexOf(" ")+1);
        let x = -tokenString.substr(0, tokenString.indexOf(" "));
        tokenString = tokenString.substr(tokenString.indexOf(" ")+1);
        let point = [y+this._offset.y, x+this._offset.x];
        let delimiter = ' ';
        if (tokenString[0] === "'" || tokenString[0] === "\"") {
            delimiter = tokenString[0];
            tokenString = tokenString.substr(1);
        }
        let label = tokenString.substr(0, tokenString.indexOf(delimiter));
        let tokens = tokenString.substr(tokenString.indexOf(delimiter)+1).trim().split(" ");
        let angle = 0;
        let angleToken = tokens.find(t => t.startsWith("U="));
        if (angleToken)
            angle = +angleToken.substr(2);
        let textHeight = this._textScale/1000.0;
        let heightToken = tokens.find(t => t.startsWith("H="));
        if (heightToken)
            textHeight *= +heightToken.substr(2);
        let textPosition = 8;
        let positionToken = tokens.find(t => t.startsWith("D"));
        if (positionToken)
            textPosition = +positionToken.substr(2);
        this.readLine();
        return new Feature({
            geometry: new Point(point, "XY"),
            labelText: label,
            textAngle: -Math.PI * angle/200.0,
            textHeight: textHeight,
            textPosition: textPosition
        })
    }

    parseGeometry(): Geometry {
        throw new Error("Method not supported.");
    }

}